import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import LottieView from 'lottie-react-native';

const RadarAnimation = ({ visible }) => {
  if (!visible) return null;

  return (
    <View style={styles.container}>
      <LottieView
        source={require('../../assets/animations/radar.json')} // Caminho corrigido
        autoPlay
        loop
        style={styles.lottie}
      />
      <Text style={styles.text}>Buscando pedidos...</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#2c5364', // Certifique-se de que a cor do fundo está consistente
    marginTop: -200, // Valor negativo para subir a animação
  },
  lottie: {
    width: 200,
    height: 200,
    backgroundColor: 'transparent', // Fundo transparente da animação
  },
  text: {
    marginTop: 20,
    fontSize: 18,
    color: '#FFF', // Texto branco para combinar com o tema
  },
});

export default RadarAnimation;